import React from 'react';
import { Box, Stack, StackProps, SxProps } from '@mui/material';
import MainField from './MainField';
import { headingFontBold } from '../../../Theme';

/** Styles for field's label. */
const fieldLabelSx: SxProps = {
    ...headingFontBold,
    fontSize: '16px',
    lineHeight: '24px',
    width: '30%',
    minWidth: '130px',
};

/**
 * Component that displays the field's view with label, icon and text.
 */
export default ({ label, text, children, ...props }: IFormFieldViewProps) => {
    return (
        <Stack sx={{ mb: 1, pr: 1 }} {...props}>
            {label && <Box sx={fieldLabelSx}>{label}</Box>}
            <Box sx={{ mr: 1 }}>{children}</Box>
            <MainField text={text} sx={{ lineHeight: '24px', fontSize: '16px' }} />
        </Stack>
    );
};

/**
 * Interface that describes FormFieldView's props.
 */
interface IFormFieldViewProps extends StackProps {
    /** The text for the text field. */
    text: string;

    /** (OPTIONAL) The label for the text field. */
    label?: string;
}
